import { forwardRef } from 'react';
import { Portal as RadixPortal } from '@radix-ui/themes';
import type { RadixPortalProps } from '@/types/radix-ui';

/**
 * Portal component - wrapper around Radix UI Portal
 * Provides portal utilities for rendering content outside the DOM hierarchy
 */
export type PortalProps = RadixPortalProps;

const Portal = forwardRef<HTMLDivElement, PortalProps>((props, ref) => {
  return <RadixPortal ref={ref} {...props} />;
});

Portal.displayName = 'Portal';

export { Portal };
